import React, { FC } from "react";
import { DescriptionColorEnum, IDescription } from "@/components/YhBox/Types";
import { Description } from "@/components/YhBox/Description";
import useGlobalModel from "@/model/globalModel";
import { RouterParamType } from "@/model/navModel";
import { useBmsBusSoDetailModel } from "../bmsBillBusSoModel";
import { formatNum } from "@/utils/utils";
export const FixedBottom: FC<RouterParamType> = ({ id, mode }) => {
    const { cm } = useGlobalModel();
    const { lookDesc } = useBmsBusSoDetailModel()
    const orderStatistics: IDescription[] = [
        {
            label: "销售项数",
            value: formatNum(lookDesc.itemNumAll),
            color: DescriptionColorEnum.red,
            status: true
        },
        {
            label: "销售数量",
            value: formatNum(lookDesc.numAll),
            color: DescriptionColorEnum.red,
            status: true
        },
        {
            label: "销售金额",
            value: formatNum(lookDesc.totalAll),
            color: DescriptionColorEnum.red,
            status: true
        },
        {
            label: "优惠金额",
            value: formatNum(lookDesc.discountAll),
            color: DescriptionColorEnum.red,
            status: true
        },
        {
            label: "应收金额",
            value: formatNum(lookDesc.receivableAll),
            color: DescriptionColorEnum.red,
            status: true
        },
    ]
    return (
        <div className="details-bot-fixed-warp" style={{ width: `calc(100% - ${cm.collapsed ? '80px' : '226px'})`, paddingLeft: "43px" }}>
            {orderStatistics.map((item, index) => <Description key={index} {...item} />)}
        </div>
    )
}